import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PrePortedNumberStatus } from '../../../shared/models/generated/ziroModels';

@Injectable()
export class OrderNumberStatusResource {
  private _http = inject(HttpClient);

  private _url = '/services/microsoft/orders/number-statuses';

  get(): Observable<PrePortedNumberStatus[]> {
    return this._http.get<PrePortedNumberStatus[]>(this._url);
  }
}
